import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OfflineDetector {
  offlineUse = false;

  constructor() {
    const ou = localStorage.getItem('offlineUse');
    if (ou) {
      this.offlineUse = ou === 'true';
    }
  }

  goOffline() {
    this.setOfflineStatus(true);
  }

  goOnline() {
    this.setOfflineStatus(false);
  }

  setOfflineStatus(status: boolean) {
    console.log('change offline status', status);
    this.offlineUse = status;
    localStorage.setItem('offlineUse', this.offlineUse + '');
  }
}
